// 缓存数据
import { defineStore } from "pinia";
import { findAllLibrary } from "@/api/system/dict";
import {
  selectWarehouse,
  selectSuperWarehouse,
} from "@/api/warehouse/warehouse";
import { listProduct } from "@/api/warehouse/product";

const useCacheStore = defineStore("cache", {
  state: () => ({
    dict: {}, // 字典
    warehouse: [], // 仓库
    product: [], // 产品
    superWarehouse: [], // 上级组织所管理的仓库，即调拨时能选择仓库
  }),
  actions: {
    // 调用后台接口，缓存所有字典
    async getCache() {
      // 仓库数据
      await this.getWarehouse();
      await this.getSuperWarehouse();
      // 产品数据
      await this.getProduct();
      // 字典数据
      await this.getDict();
    },
    // 获取仓库数据
    async getWarehouse() {
      const resWarehouse = await selectWarehouse();
      this.warehouse = resWarehouse.data;
    },

    async getSuperWarehouse() {
      const resWarehouse = await selectSuperWarehouse();
      this.superWarehouse = resWarehouse.data;
    },
    // 获取产品数据
    async getProduct() {
      const resProduct = await listProduct();
      this.product = resProduct.data;
    },
    // 获取字典数据
    async getDict() {
      const resDict = await findAllLibrary();
      this.dict = arrangeDict(resDict.data);
    },

    // 根据父code 返回 字典列表
    getDictListByParentCode(parentCode) {
      let subDictList = this.dict[parentCode];
      if (!subDictList) {
        subDictList = [];
      }
      if (parentCode == "checkStatus") {
        subDictList.forEach((item) => {
          if (item.libraryCode != "5" && item.libraryCode != "4") {
            item.disabled = true;
          }
        });
      }
      return subDictList;
    },
    // 根据父code 和子 code 返回 字典名称
    getDictNameByPCodeSCode(parentCode, subCode) {
      let subDictList = this.dict[parentCode];
      if (!subDictList) {
        subDictList = [];
      }
      let reDict = subDictList.find((item) => item.libraryCode === subCode);
      return reDict ? reDict.libraryName : subCode;
    },

    // 获取仓库名称
    getWarehouseNameById(warehouseId) {
      let reDict = this.superWarehouse.find(
        (item) => item.warehouseId === warehouseId
      );
      return reDict ? reDict.warehouseName : warehouseId;
    },
    // 获取产品
    getProductById(productId) {
      let reDict = this.product.find((item) => item.productId === productId);
      return reDict ? reDict : {};
    },
    // 根据参数获取
    getCacheValue(cacheKey, cacheCode, cacheValue, codeValue) {
      let reObject = this[cacheKey].find(
        (item) => item[cacheCode] === codeValue
      );
      return reObject ? reObject[cacheValue] : "";
    },
  },
});

// 整理字典
function arrangeDict(data) {
  const allParentDict = []; // 所有的父级字典列表
  const allSubDict = {}; // 所有的子集字典
  const reDict = {}; // 返回整理好的字典
  data.forEach((item) => {
    if (item.libraryParentId === "0") {
      allParentDict.push(item);
    } else {
      const subList = allSubDict[item.libraryParentId];
      if (subList) {
        subList.push(item);
      } else {
        allSubDict[item.libraryParentId] = [item];
      }
    }
  });

  for (let dictTypeItem of allParentDict) {
    let subList = allSubDict[dictTypeItem.libraryId];
    if (!subList) {
      subList = [];
    }
    subList = iterationChildDict(allSubDict, subList);
    reDict[dictTypeItem.libraryCode] = subList;
  }
  return reDict;
}

// 迭代自己字典
const iterationChildDict = (allSubDict, subDictList) => {
  if (subDictList.length > 0) {
    subDictList.forEach((item) => {
      let subList = allSubDict[item.libraryId];
      if (!subList) {
        subList = [];
      }
      item.child = iterationChildDict(allSubDict, subList);
    });
  }
  return subDictList;
};

export default useCacheStore;
